









































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { TypeFilterDate, Vehicle } from '../../models';
import Multiselect from 'vue-multiselect';
import {
    addAllFilterVehicleEvent,
    addFilterVehicleEvent,
    EventBus,
    Method,
    noneFilterVehicleEvent,
    TypeEventBus,
    VehicleID,
    isProductionMode,
    existItemInList,
    sortObjectByPropertyName
} from '../../utils';
import { Destroyed, Mounted } from '../../decorators';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import SelectedVehicle from './SelectedVehicle.vue';
import { event } from 'vue-analytics';
import { AuthStoreHelper } from '../../mixins';

@Component({
    components: { SelectedVehicle, Multiselect }
})
export default class MultipleSelectVehicle extends Mixins(AuthStoreHelper) {
    @Prop({ default: () => [] }) vehiclesFromSelectedCompany: Vehicle[];
    @Prop({ default: () => [] }) selectedVehicles: Vehicle[];
    @Prop() setSelectedVehicles: Method<VehicleID[], void>;
    @Prop() currentFilterSelected: number;
    @Prop({ default: true }) disableListenKey: boolean;
    @Prop({ default: false }) isMock: boolean;
    filteredVehicles: Vehicle[] = [];
    maxSelected: number | null = null;
    unSubscribe$: Subject<void> = new Subject<void>();
    isOpen: boolean = false;

    @Watch('vehiclesFromSelectedCompany')
    observableVehiclesFromSelectedCompany() {
        this.filteredVehicles = this.vehiclesFromSelectedCompany;
        this.sortVehicles();
    }

    @Watch('currentFilterSelected', { immediate: true })
    @Watch('$route', { immediate: true })
    observableCurrentFilterSelected() {
        if (this.$route.name === 'travel') {
            if (this.currentFilterSelected === TypeFilterDate.TR) {
                this.maxSelected = null;
            } else {
                if (this.selectedVehicles.length > 3) {
                    this.setSelectedVehicles([]);
                    this.isOpen = true;
                    this.multiselect.$el.focus();
                }
                this.maxSelected = 3;
            }
        } else {
            this.maxSelected = null;
        }
    }

    get disableButtonSelectAll(): boolean {
        return this.maxSelected === 3;
    }

    searchChange(searchQuery: string, id: any) {
        if (searchQuery) {
            this.filteredVehicles = this.vehiclesFromSelectedCompany.filter(vehicle =>
                this.filterHandler(vehicle, searchQuery)
            );
        } else {
            this.filteredVehicles = this.vehiclesFromSelectedCompany;
        }
        this.sortFilteredVehicles(this.selectedVehicles);
    }

    filterHandler(vehicle: Vehicle, queryText: string): boolean {
        let queryTextLowerCase = queryText.toLocaleLowerCase();
        let vehicleId =
            vehicle && vehicle.id
                ? vehicle.id
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;
        let vehicleVin =
            vehicle && vehicle.vin
                ? vehicle.vin
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;
        let vehicleDescription =
            vehicle && vehicle.description
                ? vehicle.description
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;
        let vehiclePlate =
            vehicle && vehicle.vehicle_plate
                ? vehicle.vehicle_plate
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;
        return vehicleId || vehicleVin || vehicleDescription || vehiclePlate;
    }

    handleSelectedVehicles(selectedVehicles: Vehicle[]) {
        if (!this.isMock) {
            this.setSelectedVehicles(selectedVehicles.map(vehicle => vehicle.id));
            this.sortFilteredVehicles(selectedVehicles);
            if (isProductionMode() && !this.$_getSmartwayMember) {
                //ToDO there should be a module for analytics that does this verification
                event(addFilterVehicleEvent());
            }
        }
    }

    sortVehicles(): void {
        this.filteredVehicles = this.filteredVehicles.sort(sortObjectByPropertyName('description'));
    }

    sortFilteredVehicles(selectedVehicles: Vehicle[]): void {
        this.filteredVehicles = this.filteredVehicles.sort((a, b) => {
            this.isVehicleSelected(selectedVehicles, a) ? -1 : 1;
            return this.isVehicleSelected(selectedVehicles, a)
                ? -1
                : this.isVehicleSelected(selectedVehicles, b)
                ? 1
                : a.description > b.description
                ? 1
                : -1;
        });
    }

    isVehicleSelected(selectedVehicles: Vehicle[], vehicle: Vehicle): boolean {
        return existItemInList(selectedVehicles, 'id', vehicle.id);
    }

    message(selected: number): string {
        return selected > 1 ? `${selected} vehículos seleccionados` : `${selected} vehículo seleccionado`;
    }

    showShips(): boolean {
        return this.selectedVehicles.length === 2;
    }

    handleClose(vehicles: Vehicle[]): void {
        EventBus.$emit(TypeEventBus.FILTER_VEHICLES_CLOSE, vehicles);
        this.isOpen = false;
    }

    handleOpen(): void {
        EventBus.$emit(TypeEventBus.FILTER_VEHICLES_OPEN);
        this.isOpen = true;
    }

    get multiselect(): any {
        return this.$refs.multiselect as any;
    }

    handleSelectAll(): void {
        this.handleSelectedVehicles(this.vehiclesFromSelectedCompany);
        if (isProductionMode() && !this.$_getSmartwayMember) {
            //ToDO there should be a module for analytics that does this verification
            event(addAllFilterVehicleEvent());
        }
    }

    handleSelectNone(): void {
        this.handleSelectedVehicles([]);
        if (isProductionMode() && !this.$_getSmartwayMember) {
            //ToDO there should be a module for analytics that does this verification
            event(noneFilterVehicleEvent());
        }
    }

    @Mounted
    listenKeyPressEvents(): void {
        fromEvent(document.body, 'keypress')
            .pipe(
                tap((event: KeyboardEvent) => {
                    if (!this.isOpen && !this.disableListenKey) {
                        this.multiselect.$el.focus();
                    }
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe((event: KeyboardEvent) => {});
    }

    @Mounted
    setEventBusVehiclesSelection(): void {
        //Users can filter vehicles from the map component
        EventBus.$on(TypeEventBus.SELECT_VEHICLES_FROM_MAP, selectedVehicles => {
            let vehicles: Vehicle[] = [];
            for (let i = 0; i < selectedVehicles.length; i++) {
                for (let j = 0; j < this.filteredVehicles.length; j++) {
                    if (this.filteredVehicles[j].id == selectedVehicles[i]) {
                        vehicles.push(this.filteredVehicles[j]);
                    }
                }
            }
            this.handleSelectedVehicles(vehicles);
            EventBus.$emit(TypeEventBus.FILTER_VEHICLES_CLOSE, vehicles);
            this.isOpen = false;
        });
    }

    @Mounted
    resetVehiclesMaxSelected() {
        EventBus.$on(TypeEventBus.RESET_VEHICLES_MAX_SELECTED, selectedVehicles => {
            this.maxSelected = null;
        });
    }

    @Destroyed
    clearObservables(): void {
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
    }
}
